import React, { memo, useMemo } from 'react';
import { DOMProps } from '@react-types/shared';

import { cn } from '../../../lib/css/className/className';
import './SidebarItemStub.css';
import { VStack } from '../../Stack';
import { useSidebarCollapsedState } from '../SidebarCollapsedStateProvider';
import { Stub } from '../../Stub';
import { TestProps } from '../../../internal/types/testTypes';

const cnSidebarItemStub = cn('SidebarItemStub');

export interface SidebarItemStubProps extends TestProps, DOMProps {
    withLabel?: boolean;
}

export const SidebarItemStub = memo<SidebarItemStubProps>(function SidebarItemStub({
    'data-testid': dataTestId,
    withLabel = false,
}) {
    const { isCollapsed } = useSidebarCollapsedState();

    const content = useMemo(() => {
        return (
            <VStack
                alignItems={isCollapsed ? 'center' : undefined}
                className={cnSidebarItemStub('', {
                    collapsed: isCollapsed,
                    withLabel: withLabel,
                })}
                data-testid={dataTestId ?? 'Sidebar.SidebarItemStub'}
            >
                {isCollapsed ? <Stub height={18} width={18} /> : <Stub height={16} />}
                {withLabel && <Stub className={cnSidebarItemStub('label')} height={12} width={42} />}
            </VStack>
        );
    }, [isCollapsed, dataTestId, withLabel]);

    return content;
});
